import React from "react"

// packages
import dynamic from "next/dynamic"
import "@ant-design/v5-patch-for-react-19"

// styles
import "styles/globals.scss"
import "styles/antd.scss"
import "nprogress/nprogress.css"

// contexts
import { AuthProvider } from "store/auth"
import { RestoProvider } from "store/resto"
import { SettingsProvider } from "store/settings"
import { OrderProvider } from "store/orders"
import { ReservationProvider } from "store/reservations"
import { MenuProvider } from "store/menu"
import { AppCheckProvider } from "store/appcheck"

// antd
import { ConfigProvider } from "antd"
import deDE from "antd/locale/de_DE"

// config
import config from "config"

// i18n
import "../i18n"

// sentry
import "services/sentry"

// progressbar
const AdminPanel = dynamic(
  process.env.NEXT_PUBLIC__RESTO_KEY === "resto-superadmin"
    ? () => import("components/AdminPanel")
    : () => import("components/AdminPanel.stub"),
  { ssr: false }
)

const ProgressBar = dynamic(() => import("components/ProgressBar"), {
  ssr: false,
})

function App({ Component, pageProps }) {
  // Use the layout defined at the page level, if available
  const getLayout = Component.getLayout || ((page) => page)

  // Detect Next.js default 404
  if (
    pageProps.statusCode === 404 ||
    (Component &&
      (Component.name === "Error" || Component.displayName === "Error") &&
      pageProps.statusCode === 404)
  ) {
    // Return a custom static 404 page (no providers, no JS)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          fontFamily: "sans-serif",
          background: "#fff",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h1 style={{ fontSize: "4em", margin: 0 }}>404</h1>
          <p>Sorry, this page does not exist.</p>
        </div>
      </div>
    )
  }

  if (config.key === "resto-superadmin") {
    return (
      <ConfigProvider
        locale={deDE}
        theme={{
          token: {
            colorPrimary: "rgba(0,0,0,0.88)",
          },
          components: {
            Tabs: {
              // inkBarColor: config.textColor,
            },
          },
        }}
      >
        <AppCheckProvider>
          <AuthProvider>
            <AdminPanel />
          </AuthProvider>
        </AppCheckProvider>
      </ConfigProvider>
    )
  }

  return (
    <ConfigProvider
      locale={deDE}
      theme={{
        token: {
          colorPrimary: "rgba(0,0,0,0.88)",
        },
        components: {
          Tabs: {
            // inkBarColor: config.textColor,
          },
        },
      }}
    >
      <AppCheckProvider>
        <AuthProvider>
          <RestoProvider>
            <SettingsProvider>
              <OrderProvider>
                <ReservationProvider>
                  <MenuProvider>
                    {getLayout(
                      <>
                        <Component {...pageProps} />

                        <ProgressBar />
                      </>
                    )}
                  </MenuProvider>
                </ReservationProvider>
              </OrderProvider>
            </SettingsProvider>
          </RestoProvider>
        </AuthProvider>
      </AppCheckProvider>
    </ConfigProvider>
  )
}

export default App
